import { render } from "./ExpensesModal.vue?vue&type=template&id=822f1918"
import script from "./ExpensesModal.vue?vue&type=script&lang=js"
export * from "./ExpensesModal.vue?vue&type=script&lang=js"

import exportComponent from "C:\\AgentIFAS\\_work\\45\\s\\Nezivotko.Web2\\CreditWorthiness\\real-world-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__